import { TextField } from "@mui/material";
import SystemSettingsStagingDiversion from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion";
import type { DataprocStagingEntry } from "./DataprocStagingIntegrationForm.types";
import { isGcpServiceAccount } from "./DataprocStagingIntegrationForm.utils";

interface DataprocStagingIntegrationFormProps {
  entry: DataprocStagingEntry;
  onChange: (entry: DataprocStagingEntry) => void;
}

export default function DataprocStagingIntegrationForm({
  entry,
  onChange,
}: DataprocStagingIntegrationFormProps) {
  const patchEntry = (patch: Partial<DataprocStagingEntry>) =>
    onChange({ ...entry, ...patch });

  const serviceAccount = isGcpServiceAccount(entry.run_as_service_account);

  return (
    <>
      <TextField
        label="GCP project ID"
        placeholder="e.g. definity-dev"
        value={entry.project_id}
        onChange={(e) => patchEntry({ project_id: e.target.value })}
        fullWidth
        required
        size="small"
      />
      <TextField
        label="Run as service account"
        placeholder="definity-staging@my-project.iam.gserviceaccount.com"
        value={entry.run_as_service_account}
        onChange={(e) => patchEntry({ run_as_service_account: e.target.value })}
        error={!!entry.run_as_service_account && !serviceAccount}
        helperText={
          entry.run_as_service_account && !serviceAccount
            ? "Must be a service account email (.gserviceaccount.com)"
            : "Least-privileged account the staging run is pinned to"
        }
        fullWidth
        required
        size="small"
      />
      <TextField
        label="Service account key JSON (optional)"
        type="password"
        value={entry.service_account_key ?? ""}
        onChange={(e) => patchEntry({ service_account_key: e.target.value || null })}
        helperText="Leave empty to use Workload Identity Federation (recommended)"
        fullWidth
        size="small"
      />
      <SystemSettingsStagingDiversion
        value={entry}
        onChange={patchEntry}
        scheme="gs://"
      />
    </>
  );
}
